// ============================================================================
// 📁 FILE: src/modules/ticket/components/detail/ActivityLogBlock.jsx
// 🎨 STYLE C — Full Timeline Dummy Activity Log
// ============================================================================

import React from "react";
import {
  ClockCircleOutlined,
  UserOutlined,
  CheckCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";

export default function ActivityLogBlock() {
  // Dummy history
  const logs = [
    {
      id: 1,
      type: "status",
      icon: <CheckCircleOutlined style={{ color: "#52c41a" }} />,
      text: "Status changed to In Progress",
      user: "Support Admin",
      time: "2025-12-02 10:50 AM",
    },
    {
      id: 2,
      type: "internal_note",
      icon: <EditOutlined style={{ color: "#722ed1" }} />,
      text: "Internal note added: Assigned to Network Team.",
      user: "Support Admin",
      time: "2025-12-02 10:47 AM",
    },
    {
      id: 3,
      type: "comment",
      icon: <UserOutlined style={{ color: "#1890ff" }} />,
      text: "Customer added a comment.",
      user: "Amit Sharma",
      time: "2025-12-02 10:45 AM",
    },
    {
      id: 4,
      type: "created",
      icon: <ClockCircleOutlined style={{ color: "#faad14" }} />,
      text: "Ticket created",
      user: "Amit Sharma",
      time: "2025-12-02 10:40 AM",
    },
  ];

  return (
    <div className="tf-card tf-activity-log">
      <h3 className="tf-block-title">Activity Log</h3>

      <div className="mt-3">
        {logs.map((l) => (
          <div
            key={l.id}
            className="d-flex gap-3 align-items-start mb-3"
            style={{ paddingBottom: 12, borderBottom: "1px solid #eee" }}
          >
            {/* Icon */}
            <div style={{ fontSize: 20 }}>{l.icon}</div>

            {/* Text */}
            <div>
              <div className="fw-semibold">{l.text}</div>
              <div className="small text-muted">
                {l.user} • {l.time}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
